export const GET_CHANNELS = 'programs::GET_CHANNELS';
export const GET_CHANNELS_REQUEST = 'programs::GET_CHANNELS_REQUEST';
export const GET_CHANNELS_SUCCESS = 'programs::GET_CHANNELS_SUCCESS';
export const GET_CHANNELS_FAILURE = 'programs::GET_CHANNELS_FAILURE';

export const SET_NOW_NEXT_BY_CHANNEL_ID =
    'programs::SET_NOW_NEXT_BY_CHANNEL_ID';
